import React from "react";

const AveragePriceContainer = ({varient, children}) => {
  const varients = {
    gold: "border-gold bg-gold-gradient shadow-gold",
    silver: "border-silver bg-silver-gradient shadow-silver",
    bronze: "border-bronze bg-bronze-gradient shadow-bronze",
  };
  return (
    <div
      className={` text-white border border-2 px-3 py-2 text-center font-bold text-[20px] rounded-xl ${varients[varient]}`}
    >
      {children}
    </div>
  );
};

export default AveragePriceContainer;
